import React from "react";
import localization from "../../statics/localization";
import { rentalCopy } from "../../api/mw/rental";
import "./ChannelPlaybackNotice.scss";

export default function ChannelPlaybackNotice({ denied, onRetry }) {
  const tr = localization.getLanguage() === "tr";
  return (
    <div className="channel-playback-notice" role="status">
      <p>{denied ? rentalCopy().unavailable : localization.getLanguage() === "arb" ? "بث القناة غير متاح حاليًا. حاول مجددًا." : tr
        ? "Kanal yayını şu anda alınamıyor. Lütfen tekrar deneyin."
        : "The channel stream is currently unavailable. Please try again."}</p>
      {!denied && <button type="button" onClick={onRetry}>
        {localization.getLanguage() === "arb" ? "إعادة المحاولة" : tr ? "Tekrar dene" : "Try again"}
      </button>}
    </div>
  );
}
